import Cookies from 'react-cookie/lib/Cookies';

const cookies = new Cookies();

export const getIDToken = () => cookies.get('ID_TOKEN');

export const getRefreshToken = () => cookies.get('REFRESH_TOKEN');

export const setToken = ({ id_token, access_token, expires_in }) => {
    const domain = window.location.hostname.split('.').slice(-2).join('.');
    cookies.set('ID_TOKEN', id_token, { domain, path: '/', maxAge: expires_in - 60, secure: true });
    cookies.set('ACCESS_TOKEN', access_token, { domain, path: '/', maxAge: expires_in - 60, secure: true });
};